OnlineChecker.$inject = ['$window', '$rootScope', 'toastr', 'Analytics'];

function OnlineChecker($window, $rootScope, toastr, Analytics) {
    'use strict';

    var offlineStart;
    var offlineToast;
    var offlineRefresher;
    var offlineTimer = 5000;

    $window.addEventListener('offline', function () {
        openOfflineToast();
        $rootScope.$apply(function () {
            offlineStart = Date.now() / 1000;
            $rootScope.app.online = false;
        });
    }, false);

    $window.addEventListener('online', function () {
        closeOfflineToast();
        $rootScope.$apply(function () {
            var now = Date.now() / 1000;
            Analytics.trackEvent('internetstatus', 'offline', 'timespent', (now - offlineStart).toFixed(1));
            offlineStart = null;
            $rootScope.app.online = true;
        });
    }, false);

    function openOfflineToast() {
        if (offlineToast) {
            return;
        }
        offlineToast = toastr.error('Revisa tu conexión a internet', 'Desconectado', {
            tapToDismiss: false,
            closeButton: false,
            extendedTimeOut: offlineTimer
        });
        offlineRefresher = setInterval(function () {
            if (!offlineToast) {
                return clearInterval(offlineRefresher);
            }
            toastr.refreshTimer(offlineToast, offlineTimer);
        }, offlineTimer - 1000);
    }

    function closeOfflineToast() {
        clearInterval(offlineRefresher);
        if (!offlineToast) {
            return;
        }
        toastr.remove(offlineToast.toastId);
        offlineToast = false;
    }
}

export default OnlineChecker;